module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADySURBVEhL5ZQ7CsJAEIaD4B0sPIyFImrjEbyJ3sxWrGxFG9+VZ4j/DxlYZmfMZo2NfvBBmMzOo9gt/ooZvFdOGGgDFr3CG3zCspLfbMR/U5jNBUpRzzNshEx9hFZBS+Ymb+NNvYaDSn5bOW+3kcn1ISms8Rq5m3iT12GdMTc5QStZSI1T1opYQStZSI3TJYz4+gYPaCXXYZ3hxYwYQSu5DuvMEJp4WzTRnF7wtmiiO70Q3gd51A5BTGRMP4JJ7xJvIZvwRobPclicCsznECw+ZiAXr0Er9KFu0IMf04ULuIe6wQ7OYQdms4W6sHYDf5aieAH0Kt6Y1Q3WBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-treehouse/dark/24.png
// module id = 2516
// module chunks = 2